<template>
  <div>
    <div class="p-the-page-a01 c-common-footer-fixed">
      <div class="c-common-footer-fixed__inner">
        <TheHeader
          ref="theHeader"
          @user-profile-summary="applyUserProfileSummary"
        />
        <div class="c-common-inner">
          <CMS
            contents_type="special_page"
            view_type="carousel"
            page_limit="5"
            view_area="top"
            :show_more="false"
          />
        </div>
        <div class="c-common-inner p-the-page-a01__lead">
          <!-- ポイントナビゲーション -->
          <PointNavi :grant-criteria-count="grantCriteriaCount" />
          <div
            class="p-the-page-a01__point-summary"
            :class="{
              'p-the-page-a01__point-summary--with-notice':
                pointNoticeCards.length > 0
            }"
          >
            <!-- ポイント情報 -->
            <TheA01PointInfoPanel
              v-if="theA01PointInfo.pointsLoaded"
              :exchange-points="isGroupBudget ? theA01PointInfo.groupBudgetPoint : theA01PointInfo.exchangePoints"
              :thanks-exclusive-points="theA01PointInfo.thanksExclusivePoints"
              :exchange-expire-nearest-date="theA01PointInfo.exchangeExpireNearestDate"
              :exchange-expire-nearest-points="theA01PointInfo.exchangeExpireNearestPoints"
              :thanks-exclusive-expire-nearest-date="theA01PointInfo.thanksExclusiveExpireNearestDate"
              :thanks-exclusive-expire-nearest-points="theA01PointInfo.thanksExclusiveExpireNearestPoints"
              class="p-the-page-a01__point-info"
            />
            <!-- ポイント通知カード -->
            <TheA01PointNoticeCard
              v-if="pointNoticeCards.length > 0"
              :point-notice-cards="pointNoticeCards"
              class="p-the-page-a01__point-notice"
            />
          </div>
          <!-- 新着のお知らせ -->
          <TheA01WhatsNewNoticePanel />
          <div
            v-if="isGroupBudget == false && thanksFunctionEnabled"
            id="thanks-point-area"
            class="p-the-page-a01__thanks"
          >
            <A01Heading
              :title="thanksPointName"
              class="p-the-page-a01__section__heading p-the-page-a01__section__heading--thanks"
            />
            <!-- 最新のやりとり -->
            <TheA01MessagePanel :messages="messages" />
            <!-- ポイントを贈るメリット -->
            <TheA01GiftMeritPanel />
          </div>
        </div>
        <!-- 商品交換 -->
        <div
          id="product-exchange-area"
          class="p-the-page-a01__exchange"
          :style="{
            '--site-light-color': lightColorCode
          }"
        >
          <div class="c-common-inner">
            <div class="p-the-page-a01__body">
              <div class="p-the-page-a01__main">
                <div class="p-the-page-a01__section">
                  <A01Heading
                    title="商品交換"
                    class="p-the-page-a01__section__heading p-the-page-a01__section__heading--exchange"
                    :show-button="true"
                  />
                  <div class="p-the-page-a01__item_list">
                    <!-- ICおすすめメニュータイトル -->
                    <CMS
                      contents_type="block_contents"
                      location_code="IC_TOP_01_001_menutitle"
                    />
                  </div>
                  <div class="p-the-page-a01__item_list">
                    <!-- ICおすすめメニュー -->
                    <CMS
                      contents_type="block_contents"
                      location_code="IC_TOP_01_002_menu"
                    />
                  </div>

                  <div class="p-the-page-a01__item_list">
                    <!-- ICランキングタイトル -->
                    <CMS
                      contents_type="block_contents"
                      location_code="IC_TOP_01_003_rankingtitle"
                    />
                  </div>
                  <div class="p-the-page-a01__item_list">
                    <!-- ICランキング -->
                    <CMS
                      contents_type="block_contents"
                      location_code="IC_TOP_01_004_ranking"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ポイントを獲得する方法 -->
        <TheA01EarnPointPanel
          id="earn-point-area"
          :conditions="grantCriteriaList"
          :grant-criteria-count="grantCriteriaCount"
        />
        <!-- FAQ -->
        <div
          v-show="hasFaqContents"
          class="p-the-page-a01__faq"
          :style="{
            '--site-light-color': lightColorCode
          }"
        >
          <div class="c-common-inner">
            <CMS
              contents_type="block_contents"
              location_code="IC_TOP_01_007_faq"
              @has-contents="hasFaqContents = $event"
            />
          </div>
        </div>
        <div class="p-the-page-a01__news">
          <div class="c-common-inner">
            <div class="p-the-page-a01__item_list">
              <!-- ICお知らせタイトル -->
              <CMS
                contents_type="block_contents"
                location_code="IC_TOP_01_005_newstitle"
              />
            </div>
            <div class="p-the-page-a01__item_list">
              <!-- ICお知らせ -->
              <CMS
                contents_type="block_contents"
                location_code="IC_TOP_01_006_news"
              />
            </div>
          </div>
        </div>
      </div>
      <FloatingGivePointButton />
      <TheFooter />
      <LoadingProcess />
    </div>
  </div>
</template>

<script lang="ts">
import TheA01Carousel from "@/general/components/pages/parts/Top/TheA01Carousel.vue";
import TheA01PointInfoPanel from "@/general/components/pages/parts/Top/TheA01PointInfoPanel.vue";
import TheA01PointNoticeCard from "@/general/components/pages/parts/Top/TheA01PointNoticeCard.vue";
import TheA01WhatsNewNoticePanel from "@/general/components/pages/parts/Top/TheA01WhatsNewNoticePanel.vue";
import A01Heading from "@/general/components/pages/parts/Top/A01Heading.vue";
import TheA01MessagePanel from "@/general/components/pages/parts/Top/TheA01MessagePanel.vue";
import TheA01GiftMeritPanel from "@/general/components/pages/parts/Top/TheA01GiftMeritPanel.vue";
import TheA01EarnPointPanel from "@/general/components/pages/parts/Top/TheA01EarnPointPanel.vue";
import ItemList from "@/general/components/organisms/ItemList.vue";

import CMS from "@/general/components/CMS.vue";
import PointNavi from "@/general/components/organisms/PointNavi.vue";

import {
  UserProfileSummary,
  PointNoticeCard,
  LatestMessage,
  GrantCriteria
} from "@/general/store/models";
import { Options, Vue } from "vue-class-component";
import { mapState } from "vuex";

import commons from "@/common/store/modules/commons";
import AuthStorage from "@/general/utils/auth";

import TopPageApi from "@/general/api/topPageApi";
import auth from "@/general/store/modules/auth";
import { getGrantCriteriaList } from "@/general/store/api";
import globals from "@/general/store/modules/globals";
import CONST_DATA from "@/general/mixins/const/constData";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";

@Options({
  props: {
    modal: { type: String, required: false, default: "" }
  },
  components: {
    TheA01Carousel,
    TheA01PointInfoPanel,
    TheA01PointNoticeCard,
    TheA01WhatsNewNoticePanel,
    A01Heading,
    TheA01MessagePanel,
    TheA01GiftMeritPanel,
    TheA01EarnPointPanel,
    ItemList,
    CMS,
    PointNavi
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode,
      storeLightColorCode: () => commons.lightColorCode
    })
  }
})
export default class TopPage extends Vue {
  modal!: string;

  storeColorCode: string;
  storeLightColorCode: string;
  pointNoticeCards: PointNoticeCard[] = [];
  theA01PointInfo = {
    pointsLoaded: false,
    exchangePoints: 0,
    pointsExpiringSoon: 0,
    pointsExpiringCount: 0,
    grantPoints: 0,
    thanksExclusivePoints: 0,
    groupBudgetPoint: 0,
    exchangeExpireNearestDate: "",
    exchangeExpireNearestPoints: 0,
    thanksExclusiveExpireNearestDate: "",
    thanksExclusiveExpireNearestPoints: 0
  };
  messages: any = [];
  grantCriteriaCount = 0;
  grantCriteriaList: GrantCriteria[] = [];
  hasFaqContents = false;

  declare refs: {
    theHeader: any;
  };

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }

  get colorCode() {
    if (this.isGroupBudget) {
      return "#fc9014";
    }
    return this.storeColorCode;
  }

  get lightColorCode() {
    if (this.isGroupBudget) {
      return "#FFF5E8";
    }
    return this.storeLightColorCode;
  }

  get thanksFunctionEnabled() {
    return commons.thanksFunctionEnabled;
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }

  get color(): string {
    return this.colorCode;
  }
  get pageSize() {
    return commons?.pageSize ? commons.pageSize : 10;
  }
  get isSp(): boolean {
    return globals.isLargeBreakpointWidthOfSp;
  }
  get isRegifted() {
    return auth.user?.allow_points_regifting;
  }

  async created() {
    await globals.setLoadingProcess(true);

    await commons.setOrgPageSpecificDataFromLocalStorage();

    AuthStorage.checkLogin();

    this.pointNoticeCards = await TopPageApi.getPointNoticeCard();
    try {
      const grantCriteriaList = await getGrantCriteriaList("", 1, 3, "");
      this.grantCriteriaCount = grantCriteriaList.count || 0;
      this.grantCriteriaList = grantCriteriaList.results || [];
    } catch {
      this.grantCriteriaCount = 0;
      this.grantCriteriaList = [];
    }
    await TopPageApi.getLatestMessages()
      .then((latestMessages) => {
        latestMessages.map((item: LatestMessage) => {
          this.messages.push({
            date: item.sendTime,
            message: item.messages,
            fromUserName: item.fromUserName,
            toUserName: item.toUserName,
            points: item.points
          });
        });
      })
      .catch((e) => {
        console.log(e);
      });

    await globals.setLoadingProcess(false);
  }

  applyUserProfileSummary(userSummary: UserProfileSummary) {
    if (Object.keys(userSummary).length > 0) {
      this.theA01PointInfo.exchangePoints = userSummary.total_points;
      this.theA01PointInfo.pointsExpiringSoon = userSummary.points_expire_soon;
      this.theA01PointInfo.pointsExpiringCount =
        userSummary?.points_expire_soon_count;
      this.theA01PointInfo.thanksExclusivePoints =
        userSummary?.thanks_exclusive_points;
      this.theA01PointInfo.pointsLoaded = true;
      this.theA01PointInfo.grantPoints =
        userSummary?.grant_points + userSummary?.kenko_points;
      this.theA01PointInfo.groupBudgetPoint = userSummary?.group_budget_point;
      this.theA01PointInfo.exchangeExpireNearestDate =
        userSummary?.exchange_expire_nearest_date || "";
      this.theA01PointInfo.exchangeExpireNearestPoints =
        userSummary?.exchange_expire_nearest_points || 0;
      this.theA01PointInfo.thanksExclusiveExpireNearestDate =
        userSummary?.thanks_exclusive_expire_nearest_date || "";
      this.theA01PointInfo.thanksExclusiveExpireNearestPoints =
        userSummary?.thanks_exclusive_expire_nearest_points || 0;
    }
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-a01 {
  background-color: $common-bg;

  .c-common-inner {
    background-color: $common-bg;
  }

  &__lead {
    padding-top: rem(24);
  }

  &__point-summary {
    display: flex;
    gap: rem(24);
    align-items: flex-start;
    margin-bottom: rem(16);

    .p-the-page-a01__point-info {
      flex: 1;
      min-width: 0;
    }

    &--with-notice {
      .p-the-page-a01__point-notice {
        flex: none;
        width: rem(303);
      }
    }

    @include large-sp {
      flex-direction: column;
      gap: rem(16);

      &--with-notice {
        .p-the-page-a01__point-notice {
          width: 100%;
        }
      }
    }
  }

  &__body {
    display: flex;
    justify-content: space-between;

    @include large-sp {
      display: block;
      padding: rem(40) 0;
    }
  }

  &__main {
    flex: 1;
    min-width: 0;

    @include large-pc {
      padding: 0 0 rem(56);
    }
  }

  &__thanks {
    margin-bottom: rem(16);
  }

  &__section {
    margin-top: rem(56);

    @include large-sp {
      margin-top: rem(40);
    }

    &__heading {
      margin-bottom: rem(32);

      @include large-sp {
        margin-bottom: rem(24);
      }

      &--thanks {
        margin-bottom: rem(24);

        :deep(.p-a01-heading) {
          overflow-wrap: anywhere;
        }
      }

      &--exchange {
        margin-bottom: rem(40);

        @include large-sp {
          margin-bottom: rem(24);
        }
      }
    }
  }

  &__exchange {
    width: 100%;
    background-color: var(--site-light-color);
    padding: rem(64) 0;

    @include large-sp {
      padding: rem(32) 0;
    }

    .c-common-inner {
      background-color: transparent;
    }

    .p-the-page-a01__body {
      @include large-sp {
        padding: 0;
      }
    }

    .p-the-page-a01__main {
      @include large-pc {
        padding: 0;
      }
    }

    .p-the-page-a01__section {
      margin-top: 0;
    }
  }

  &__faq {
    width: 100%;
    padding: rem(64) 0;
    background-color: var(--site-light-color);
    font-family: $font--noto-sans-only;

    @include large-sp {
      padding: rem(32) 0;
    }

    .c-common-inner {
      background-color: transparent;
    }
  }

  &__block {
    margin-top: rem(56);

    @include large-sp {
      margin-top: rem(40);
    }

    &:first-of-type {
      margin-top: 0;
    }
  }

  &__item_list {
    margin-top: rem(32);

    @include large-sp {
      margin-top: rem(16);
    }

    &__btn {
      display: flex;
      justify-content: center;
      margin-top: rem(32);
    }
  }
}
</style>
